/**
 * Load components.
 */

require('./after-libs/color-scheme');
require('./after-libs/modal');
require('./after-libs/retro-style');
require('./after-libs/web-fonts');